// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"29":"file-upload","883":"shop","945":"dashboard"}[chunkId] || chunkId) + "." + {"29":"1c85997a","663":"c4b99b5a","883":"9d9fcbb9","945":"562dfb8a"}[chunkId] + ".css";
};